import React, { useEffect, useState, useRef } from 'react'
import FilterBar from '../Filter/FilterBar'
import { ImAndroid } from "react-icons/im";
import { FaAppStoreIos, FaChrome, FaStethoscope, FaUser, FaUsers, FaUserPlus, FaApple, FaHeartbeat, FaCalendarAlt, FaWalking, FaUserEdit } from "react-icons/fa";
import { FaDroplet } from "react-icons/fa6";
import { HiScale } from "react-icons/hi";
import { TbTriangleSquareCircleFilled, TbMoodSmileFilled } from "react-icons/tb";
import { MdBloodtype } from "react-icons/md";
import { IoIosBookmarks, IoIosDocument } from "react-icons/io";
import { LuMicroscope } from "react-icons/lu";
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { getuserdata, fetchDashboardData, fetchDashboardStats, fetchModuleUsageStats, fetchUsersLocation } from "./store";
import GenderDistribution from './GenderDistribution';
import FeatureUsage from './FeatureUsage';
import MainFocusAreas from './MainFocusAreas';
import WaterIntakeChart from './WaterIntakeChart';
import StepsTrackerChart from './StepsTrackerChart';
import { useDispatch } from 'react-redux';
import Loader, { ComponentLoader } from '../common/Loader';
import { Form, Spinner } from 'react-bootstrap';
import OverallModuleUsage from './overallModuleUsage';


import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const Home = () => {
  const dataFetchedRef = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [totaliOS, setTotaliOS] = useState(null);
  const [totalAndroid, setTotalAndroid] = useState(null);
  const [totalWeb, setTotalWeb] = useState(null);
  const [totalUsers, setTotalUsers] = useState(null);

  const [bloodDonateTotal, setBloodDonateTotal] = useState(null);
  const [moodMonitorTotal, setMoodMonitorTotal] = useState(null);
  const [documentUploadsTotal, setDocumentUploadsTotal] = useState(null);
  const [bloodPressureTotal, setBloodPressureTotal] = useState(null);
  const [bloodSugarTotal, setBloodSugarTotal] = useState(null);

  // Dashboard Stats State
  const [statsTotalUsers, setStatsTotalUsers] = useState(null);
  const [statsPeriodTracking, setStatsPeriodTracking] = useState(null);
  const [statsBloodPressure, setStatsBloodPressure] = useState(null);
  const [statsActiveMoodLogs, setStatsActiveMoodLogs] = useState(null);
  const [statsBloodSugar, setStatsBloodSugar] = useState(null);
  const [statsActiveUsers, setStatsActiveUsers] = useState(null);
  const [statsTodayRegistration, setStatsTodayRegistration] = useState(null);
  const [statsMonthRegistration, setStatsMonthRegistration] = useState(null);
  const [statsTodayActiveUsers, setStatsTodayActiveUsers] = useState(null);
  const [statsWeekActiveUsers, setStatsWeekActiveUsers] = useState(null);
  const [statsMonthActiveUsers, setStatsMonthActiveUsers] = useState(null);
  const [statsIncompleteProfileUsers, setStatsIncompleteProfileUsers] = useState(null);

  const localname = localStorage.name

  const {
    control,
    setValue,
    formState: { },
    reset,
  } = useForm();

  const [locations, setLocations] = useState([]);
  const [dates, setDates] = useState([]);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    const cacheKey = 'DASHBOARD_CACHE';
    let cacheExists = false;

    const cachedData = sessionStorage.getItem(cacheKey);
    if (cachedData) {
      const data = JSON.parse(cachedData);
      if (data === 'PENDING') {
        return;
      }

      if (data && typeof data === 'object') {
        const cacheTimestamp = data.cacheTimestamp || 0;
        const threeMinutes = 3 * 60 * 1000;
        const isExpired = Date.now() - cacheTimestamp > threeMinutes;

        if (!isExpired) {
          setTotaliOS(data.totaliOS);
          setTotalAndroid(data.totalAndroid);
          setTotalWeb(data.totalWeb);
          setTotalUsers(data.totalUsers);
          setDates(data.dates);
          setBloodDonateTotal(data.bloodDonateTotal);
          setMoodMonitorTotal(data.moodMonitorTotal);
          setDocumentUploadsTotal(data.documentUploadsTotal);
          setBloodPressureTotal(data.bloodPressureTotal);
          setBloodSugarTotal(data.bloodSugarTotal);
          setStatsTotalUsers(data.statsTotalUsers);
          setStatsIncompleteProfileUsers(data.statsIncompleteProfileUsers);
          setStatsPeriodTracking(data.statsPeriodTracking);
          setStatsBloodPressure(data.statsBloodPressure);
          setStatsActiveMoodLogs(data.statsActiveMoodLogs);
          setStatsBloodSugar(data.statsBloodSugar);
          setStatsActiveUsers(data.statsActiveUsers);
          setStatsTodayRegistration(data.statsTodayRegistration);
          setStatsMonthRegistration(data.statsMonthRegistration);
          setStatsTodayActiveUsers(data.statsTodayActiveUsers);
          setStatsWeekActiveUsers(data.statsWeekActiveUsers);
          setStatsMonthActiveUsers(data.statsMonthActiveUsers);
          setLocations(data.locations);
          dataFetchedRef.current = true;
          return;
        } else {
          setTotaliOS(data.totaliOS);
          setTotalAndroid(data.totalAndroid);
          setTotalWeb(data.totalWeb);
          setTotalUsers(data.totalUsers);
          setDates(data.dates);
          setBloodDonateTotal(data.bloodDonateTotal);
          setMoodMonitorTotal(data.moodMonitorTotal);
          setDocumentUploadsTotal(data.documentUploadsTotal);
          setBloodPressureTotal(data.bloodPressureTotal);
          setBloodSugarTotal(data.bloodSugarTotal);
          setStatsTotalUsers(data.statsTotalUsers);
          setStatsIncompleteProfileUsers(data.statsIncompleteProfileUsers);
          setStatsPeriodTracking(data.statsPeriodTracking);
          setStatsBloodPressure(data.statsBloodPressure);
          setStatsActiveMoodLogs(data.statsActiveMoodLogs);
          setStatsBloodSugar(data.statsBloodSugar);
          setStatsActiveUsers(data.statsActiveUsers);
          setStatsTodayRegistration(data.statsTodayRegistration);
          setStatsMonthRegistration(data.statsMonthRegistration);
          setStatsTodayActiveUsers(data.statsTodayActiveUsers);
          setStatsWeekActiveUsers(data.statsWeekActiveUsers);
          setStatsMonthActiveUsers(data.statsMonthActiveUsers);
          setLocations(data.locations);
          cacheExists = true;
        }
      }
    }
    sessionStorage.setItem(cacheKey, JSON.stringify('PENDING'));
    dataFetchedRef.current = true;

    const dashboardCache = {};
    try {
      // Parallelize API calls for better performance
      const [userRes, dashRes, statsRes, locRes] = await Promise.allSettled([
        dispatch(getuserdata()),
        dispatch(fetchDashboardData()),
        dispatch(fetchDashboardStats()),
        dispatch(fetchUsersLocation())
      ]);

      // 1. Process User Data
      if (userRes.status === 'fulfilled' && userRes.value.payload) {
        const TempData = userRes.value.payload;
        const deviceStats = TempData.deviceStatistics || {};
        const res_date = TempData.createdDates || [];
        const ios = deviceStats.iOS || 0;
        const android = deviceStats.Android || 0;
        const web = deviceStats.Web || 0;
        const total = ios + android + web;

        setTotaliOS(ios);
        setTotalAndroid(android);
        setTotalWeb(web);
        setTotalUsers(total);
        setDates(res_date);

        dashboardCache.totaliOS = ios;
        dashboardCache.totalAndroid = android;
        dashboardCache.totalWeb = web;
        dashboardCache.totalUsers = total;
        dashboardCache.dates = res_date;
      }

      // 2. Process Dashboard Data
      if (dashRes.status === 'fulfilled' && dashRes.value.payload) {
        const data = dashRes.value.payload;
        const bdt = data.bloodDonate?.length || 0;
        const mmt = data.moodMonitor?.length || 0;
        const dut = data.documentUploads?.length || 0;
        const bpt = data.bloodPressure?.length || 0;
        const bst = data.bloodSugar?.length || 0;

        setBloodDonateTotal(bdt);
        setMoodMonitorTotal(mmt);
        setDocumentUploadsTotal(dut);
        setBloodPressureTotal(bpt);
        setBloodSugarTotal(bst);

        dashboardCache.bloodDonateTotal = bdt;
        dashboardCache.moodMonitorTotal = mmt;
        dashboardCache.documentUploadsTotal = dut;
        dashboardCache.bloodPressureTotal = bpt;
        dashboardCache.bloodSugarTotal = bst;
      }

      // 3. Process Dashboard Stats
      if (statsRes.status === 'fulfilled' && statsRes.value.payload?.success) {
        const sData = statsRes.value.payload.data;
        setStatsTotalUsers(sData.totalUsers || 0);
        setStatsIncompleteProfileUsers(sData.incompleteProfileUsers || 0);
        setStatsPeriodTracking(sData.periodTracking || 0);
        setStatsBloodPressure(sData.bloodPressure || 0);
        setStatsActiveMoodLogs(sData.activeMoodLogs || 0);
        setStatsBloodSugar(sData.bloodSugar || 0);
        setStatsActiveUsers(sData.activeUsers || 0);
        setStatsTodayRegistration(sData.todayRegistration || 0);
        setStatsMonthRegistration(sData.MonthRegistration || 0);
        setStatsTodayActiveUsers(sData.todayActiveUsers || 0);
        setStatsWeekActiveUsers(sData.weekActiveUsers || 0);
        setStatsMonthActiveUsers(sData.monthActiveUsers || 0);

        dashboardCache.statsTotalUsers = sData.totalUsers || 0;
        dashboardCache.statsIncompleteProfileUsers = sData.incompleteProfileUsers || 0;
        dashboardCache.statsPeriodTracking = sData.periodTracking || 0;
        dashboardCache.statsBloodPressure = sData.bloodPressure || 0;
        dashboardCache.statsActiveMoodLogs = sData.activeMoodLogs || 0;
        dashboardCache.statsBloodSugar = sData.bloodSugar || 0;
        dashboardCache.statsActiveUsers = sData.activeUsers || 0;
        dashboardCache.statsTodayRegistration = sData.todayRegistration || 0;
        dashboardCache.statsMonthRegistration = sData.MonthRegistration || 0;
        dashboardCache.statsTodayActiveUsers = sData.todayActiveUsers || 0;
        dashboardCache.statsWeekActiveUsers = sData.weekActiveUsers || 0;
        dashboardCache.statsMonthActiveUsers = sData.monthActiveUsers || 0;
      }

      // 4. Process Locations
      if (locRes.status === 'fulfilled' && locRes.value.payload?.success) {
        setLocations(locRes.value.payload.data);
        dashboardCache.locations = locRes.value.payload.data;
      }

      if (Object.keys(dashboardCache).length > 0) {
        dashboardCache.cacheTimestamp = Date.now();
        sessionStorage.setItem(cacheKey, JSON.stringify(dashboardCache));
      } else {
        sessionStorage.removeItem(cacheKey);
      }
    } catch (e) {
      console.error("Critical error loading dashboard data:", e);
      sessionStorage.removeItem(cacheKey);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);



  useEffect(() => {
    if (!Array.isArray(dates) || dates.length === 0) return;

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const monthActivityMap = {};

    dates.forEach(date => {
      const monthIndex = new Date(date).getMonth();
      const monthName = monthNames[monthIndex];

      monthActivityMap[monthName] = (monthActivityMap[monthName] || 0) + 1;
    });

    const chartData = monthNames.map(month => ({
      name: month,
      activity: monthActivityMap[month] || 0, // Default 0 for missing months
    }));

    setData(chartData);
  }, [dates]);

  const [term, setTerm] = useState(""); // User input
  const [icdCodes, setICDCodes] = useState([]); // List of ICD codes
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [medlineData, setMedlineData] = useState(null); // MedlinePlus data

  // Fetch ICD-10 codes based on user input
  const fetchICDCodes = async (searchTerm) => {
    setLoading(true);
    setError(null);
    setICDCodes([]);
    setMedlineData(null);

    try {
      // Example API for ICD-10 codes (Replace with a valid API)
      const response = await fetch(
        `https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=${searchTerm}`
      );
      if (!response.ok) {
        throw new Error("Error fetching ICD-10 codes.");
      }
      const result = await response.json();

      // Extract matching ICD-10 codes and descriptions
      const codes = result[3].map((item, index) => ({
        code: item[0], // ICD code
        description: item[1], // Description
      }));
      setICDCodes(codes);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch MedlinePlus data for an ICD-10 code
  const fetchMedlinePlusData = async (code) => {
    setLoading(true);
    setError(null);
    setMedlineData(null);

    try {
      const response = await fetch(
        `https://connect.medlineplus.gov/service?mainSearchCriteria.v.c=${code}&mainSearchCriteria.v.cs=2.16.840.1.113883.6.90&knowledgeResponseType=application/json`
      );
      if (!response.ok) {
        throw new Error("Error fetching MedlinePlus data.");
      }
      const result = await response.json();

      setMedlineData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Handle search when the user submits a term
  const handleSearch = async () => {
    if (!term) return;
    await fetchICDCodes(term); // Fetch matching ICD-10 codes
  };

  const getTodayStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };
  const getStartOfMonthStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
  };
  const getStartOfWeekStr = () => {
    const d = new Date();
    d.setDate(d.getDate() - 7);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  return (
    <>

      <div className='container_alluser'>

        {/* Dashboard Stats Cards - Row 1 */}
        <div style={{ display: 'flex', gap: '20px', padding: '20px 0 10px', flexWrap: 'wrap' }}>
          {/* Total Users */}
          <div onClick={() => navigate('/Users')} style={{ flex: '1', minWidth: '200px', background: '#eff6ff', border: '1px solid #3b82f6', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>Total Users</p>
                {statsTotalUsers !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600, color: '#000000ff' }}>{statsTotalUsers}</h2>
                ) : (
                  <ComponentLoader color="#3b82f6" padding="10px 0" />
                )}
              </div>
              <div style={{ background: '#3b82f6', borderRadius: '10px', padding: '12px' }}>
                <FaUser style={{ color: '#ffffff', fontSize: '24px' }} />
              </div>
            </div>
          </div>

          {/* Active Users */}
          <div
            onClick={() => navigate('/Users?loginStatus=A&viewTitle=Active+Logins')}
            style={{ flex: '1', minWidth: '200px', background: '#ecfdf5', border: '1px solid #10b981', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>Active Logins</p>
                {statsActiveUsers !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600, color: '#000000ff' }}>{statsActiveUsers}</h2>
                ) : (
                  <ComponentLoader color="#10b981" padding="10px 0" />
                )}
              </div>
              <div style={{ background: '#10b981', borderRadius: '10px', padding: '12px' }}>
                <FaUsers style={{ color: '#ffffff', fontSize: '24px' }} />
              </div>
            </div>
          </div>

          {/* Current Month Registration */}
          <div onClick={() => navigate(`/Users?startDate=${getStartOfMonthStr()}&endDate=${getTodayStr()}&viewTitle=Current+Month+Registration`)} style={{ flex: '1', minWidth: '200px', background: '#fef2f2', border: '1px solid #ef4444', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>Current Month Registration</p>
                {statsMonthRegistration !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600, color: '#000000ff' }}>{statsMonthRegistration}</h2>
                ) : (
                  <ComponentLoader color="#ef4444" padding="10px 0" />
                )}
              </div>
              <div style={{ background: '#ef4444', borderRadius: '10px', padding: '12px' }}>
                <FaCalendarAlt style={{ color: '#ffffff', fontSize: '24px' }} />
              </div>
            </div>
          </div>

          {/* New Registration Today */}
          <div
            onClick={() => navigate(`/Users?startDate=${getTodayStr()}&endDate=${getTodayStr()}&viewTitle=Today+Registrations`)}
            style={{ flex: '1', minWidth: '200px', background: '#fdf4ff', border: '1px solid #d946ef', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>New Registration Today</p>
                {statsTodayRegistration !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600, color: '#000000ff' }}>{statsTodayRegistration}</h2>
                ) : (
                  <ComponentLoader color="#d946ef" padding="10px 0" />
                )}
              </div>
              <div style={{ background: '#d946ef', borderRadius: '10px', padding: '12px' }}>
                <FaUserPlus style={{ color: '#ffffff', fontSize: '24px' }} />
              </div>
            </div>
          </div>
        </div>

        {/* Dashboard Stats Cards - Row 2 */}
        <div style={{ display: 'flex', gap: '20px', padding: '10px 0 20px', flexWrap: 'wrap', marginBottom: '20px' }}>
          {/* Current Month Active Users */}
          <div onClick={() => navigate(`/Users?dateFilterType=lastActive&startDate=${getStartOfMonthStr()}&endDate=${getTodayStr()}&viewTitle=Current+Month+Active+Users`)} style={{ flex: '1', minWidth: '200px', background: '#f0f9ff', border: '1px solid #0ea5e9', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>Current Month Active Users</p>
                {statsMonthActiveUsers !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600, color: '#000000ff' }}>{statsMonthActiveUsers}</h2>
                ) : (
                  <ComponentLoader color="#0ea5e9" padding="10px 0" />
                )}
              </div>
              <div style={{ background: '#0ea5e9', borderRadius: '10px', padding: '12px' }}>
                <FaUsers style={{ color: '#ffffff', fontSize: '24px' }} />
              </div>
            </div>
          </div>

          {/* Current Week Active Users */}
          <div onClick={() => navigate(`/Users?dateFilterType=lastActive&startDate=${getStartOfWeekStr()}&endDate=${getTodayStr()}&viewTitle=Current+Week+Active+Users`)} style={{ flex: '1', minWidth: '200px', background: '#eef2ff', border: '1px solid #6366f1', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>Current Week Active Users</p>
                {statsWeekActiveUsers !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600, color: '#000000ff' }}>{statsWeekActiveUsers}</h2>
                ) : (
                  <ComponentLoader color="#6366f1" padding="10px 0" />
                )}
              </div>
              <div style={{ background: '#6366f1', borderRadius: '10px', padding: '12px' }}>
                <FaUsers style={{ color: '#ffffff', fontSize: '24px' }} />
              </div>
            </div>
          </div>

          {/* Today Active Users */}
          <div onClick={() => navigate(`/Users?dateFilterType=lastActive&startDate=${getTodayStr()}&endDate=${getTodayStr()}&viewTitle=Today+Active+Users`)} style={{ flex: '1', minWidth: '200px', background: '#faf5ff', border: '1px solid #a855f7', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>Today Active Users</p>
                {statsTodayActiveUsers !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600, color: '#000000ff' }}>{statsTodayActiveUsers}</h2>
                ) : (
                  <ComponentLoader color="#a855f7" padding="10px 0" />
                )}
              </div>
              <div style={{ background: '#a855f7', borderRadius: '10px', padding: '12px' }}>
                <FaUsers style={{ color: '#ffffff', fontSize: '24px' }} />
              </div>
            </div>
          </div>
            
            {/* incomplte- it will be in next phase */}

           <div onClick={() => navigate('/Users?userDataFlag=I&viewTitle=Incomplete+Profile+Users')} style={{ flex: '1', minWidth: '200px', background: '#fffbeb', border: '1px solid #f59e0b', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>Incomplete Profile Users</p>
                {statsIncompleteProfileUsers !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600, color: '#000000ff' }}>{statsIncompleteProfileUsers}</h2>
                ) : (
                  <ComponentLoader color="#f59e0b" padding="10px 0" />
                )}
              </div>
              <div style={{ background: '#f59e0b', borderRadius: '10px', padding: '12px' }}>
                <FaUserEdit style={{ color: '#ffffff', fontSize: '24px' }} />
              </div>
            </div>
          </div>
        </div>

        <div className='users_action' >
          {false && (<div className='useraction_wrapper'>
            <div className='userAct Appoinment' >
              <div className='userAct_container'>
                <h5>Appoinments</h5>
                <div className='icon_text'>
                  <div className="userAct_outer_circle">
                    <div className="userAct_inner_circle">
                      <div className='users_icon_size'>
                        <IoIosBookmarks className='Appoinment' />
                      </div>
                    </div>
                  </div>
                  <div className='usernumber'>
                    <div className='usersAct_numbers'>600k books</div>

                  </div>
                </div>

              </div>
            </div>
            {/* blooddonation */}
            <div className='userAct blood_donation'>
              <div className='userAct_container'>
                <h5>blood donation</h5>
                <div className='icon_text'>
                  <div className="userAct_outer_circle">
                    <div className="userAct_inner_circle">
                      <div className='users_icon_size'>
                        <MdBloodtype className='blooddonation' />
                      </div>
                    </div>
                  </div>
                  <div className='usernumber'>
                    <div className='usersAct_numbers'>{bloodDonateTotal} donates</div>

                  </div>
                </div>

              </div>
            </div>
          </div>)}
          {/* blooddonation */}
          <div className='useraction_wrapper'>
            {false && (<div className='userAct mood_monitor'>
              <div className='userAct_container'>
                <h5>Mood Monitor</h5>
                <div className='icon_text'>
                  <div className="userAct_outer_circle">
                    <div className="userAct_inner_circle">
                      <div className='users_icon_size'>
                        <TbMoodSmileFilled className='mood_monitor' />
                      </div>
                    </div>
                  </div>
                  <div className='usernumber'>
                    <div className='usersAct_numbers'>{moodMonitorTotal} entered</div>

                  </div>
                </div>

              </div>
            </div>)}
            {/* blooddonation */}
            {false && (<div className='userAct Document'>
              <div className='userAct_container'>
                <h5>document upload</h5>
                <div className='icon_text'>
                  <div className="userAct_outer_circle">
                    <div className="userAct_inner_circle">
                      <div className='users_icon_size'>
                        <IoIosDocument className='Document' />
                      </div>
                    </div>
                  </div>
                  <div className='usernumber'>
                    <div className='usersAct_numbers'>{documentUploadsTotal} uploads</div>

                  </div>
                </div>

              </div>
            </div>)}
          </div>
          {/* blooddonation */}

          <div className='useraction_wrapper'>
            {false && (<div className='userAct blood_sugar'>
              <div className='userAct_container'>
                <h5>blood Pressure</h5>
                <div className='icon_text'>
                  <div className="userAct_outer_circle">
                    <div className="userAct_inner_circle">
                      <div className='users_icon_size'>
                        <FaStethoscope className='bloodpresure' />
                      </div>
                    </div>
                  </div>
                  <div className='usernumber'>
                    <div className='usersAct_numbers'>{bloodPressureTotal} records</div>

                  </div>
                </div>

              </div>
            </div>)}
            {/* blooddonation */}
            {false && (<div className='userAct bloodpresure'>
              <div className='userAct_container'>
                <h5>blood Sugar</h5>

                <div className='icon_text'>
                  <div className="userAct_outer_circle">
                    <div className="userAct_inner_circle">
                      <div className='users_icon_size'>
                        <LuMicroscope className='blood_sugar' />
                      </div>
                    </div>
                  </div>
                  <div className='usernumber'>
                    <div className='usersAct_numbers'>{bloodSugarTotal} records</div>
                  </div>
                </div>
              </div>
            </div>)}
          </div>

        </div>

        {/* user charts and location */}
        <div className='user_charts_locations'>
          {false && (<div className="user_charts_container">

            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" tick={{ fontSize: 10 }} />
                <YAxis tick={{ fontSize: 10 }} />
                <Tooltip />
                <Line type="monotone" dataKey="activity" stroke="#8884d8" />
              </LineChart>
            </ResponsiveContainer>
          </div>)}
          {false && (<div className='user_location_container'>
            <h3>User location</h3>
            <div className='state_con'>
              <div className='state'>
                <h4>Tamil Nadu  <div>4 users</div></h4>

              </div>
              <div className='state'>
                <h4>kerala  <div>4 users</div></h4>

              </div>
              <div className='state'>
                <h4>vellore  <div>4 users</div></h4>

              </div>
              <div className='state'>
                <h4>delhi  <div>4 users</div></h4>

              </div>
              <div className='state'>
                <h4>Mumbai  <div>4 users</div></h4>

              </div>
            </div>
          </div>)}
        </div>

        {/* Dashboard Main Layout - Two Column Structure for Exact Width Alignment */}
        <div style={{ display: 'flex', gap: '20px', marginTop: '0px', flexWrap: 'wrap', alignItems: 'flex-start' }}>

          {/* Column 1 (Narrower - matches Feature Usage) */}
          <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '20px', minWidth: '400px' }}>
            {/* Sub-row for Gender and Devices */}
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              <div style={{ flex: '1' }}>
                <GenderDistribution locations={locations} />
              </div>

              <div style={{
                flex: '1',
                background: '#fff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                display: 'flex',
                flexDirection: 'column',
                minWidth: '220px',
                height: '450px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
                  <div style={{ width: '4px', height: '20px', background: '#10b981', borderRadius: '2px' }}></div>
                  <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }}>Platform Distribution</h3>
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0' }}>
                  <div style={{
                    position: 'relative',
                    width: '250px',
                    height: '250px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    border: '8px solid #f9fafb',
                    boxShadow: 'inset 0 4px 8px rgba(0,0,0,0.05)'
                  }}>
                    {/* Upper Half: Android */}
                    <div
                      onClick={() => navigate('/Users?Android')}
                      style={{
                        flex: 1,
                        background: '#e9ffed',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        borderBottom: '1px solid #fff',
                        transition: 'all 0.3s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#d3fae1ff';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#e9ffed';
                      }}
                    >
                      <p style={{ margin: 0, fontSize: '13px', fontWeight: '600', color: '#15803d', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>Android Users</p>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', width: '100%' }}>
                        <ImAndroid style={{ color: '#22c55e', fontSize: '36px' }} />
                        <span style={{ fontSize: '26px', fontWeight: '700', color: '#166534', position: 'relative', top: '2px', lineHeight: '1' }}>
                          {totalAndroid !== null ? totalAndroid : <ComponentLoader color="#22c55e" size="18px" padding="0" />}
                        </span>
                      </div>
                    </div>

                    {/* Lower Half: iOS */}
                    <div
                      onClick={() => navigate('/Users?iOS')}
                      style={{
                        flex: 1,
                        background: '#eff6ff',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#cce1fcff';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#eff6ff';
                      }}
                    >
                      <p style={{ margin: 0, fontSize: '13px', fontWeight: '600', color: '#1d4ed8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>iOS Users</p>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', width: '100%' }}>
                        <FaApple style={{ color: '#3b82f6', fontSize: '36px' }} />
                        <span style={{ fontSize: '26px', fontWeight: '700', color: '#1e40af', position: 'relative', top: '2px', lineHeight: '1' }}>
                          {totaliOS !== null ? totaliOS : <ComponentLoader color="#3b82f6" size="18px" padding="0" />}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <FeatureUsage locations={locations} />
          </div>

          {/* Column 2 (Right - 50% split) */}
          <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '20px', minWidth: '400px' }}>
            <MainFocusAreas />
            <StepsTrackerChart />
          </div>
        </div>
        <div style={{ display: 'flex', gap: '20px', padding: '20px 0', flexWrap: 'wrap', marginBottom: '20px' }}>
          {/* <WaterIntakeChart /> */}
          {/* Period Tracking (F) */}
          <div onClick={() => navigate('/mood-analytics')} style={{ flex: '1', minWidth: '200px', background: '#f3729dff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '16px', color: '#fffeffff' }}>Active Mood Logs</p>
                {statsActiveMoodLogs !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600 }}>{statsActiveMoodLogs}</h2>
                ) : (
                  <ComponentLoader color="#ef4444" padding="10px 0" />
                )}
                {/* <p style={{ margin: 0, fontSize: '12px', color: '#10b981' }}>↗ +5% from last month</p> */}
              </div>
              <div style={{ background: '#fef2f2', borderRadius: '10px', padding: '12px' }}>
                <TbMoodSmileFilled style={{ color: '#ef4444', fontSize: '24px' }} />
              </div>
            </div>
          </div>

          {/* Blood Pressure Usage */}
          <div
            onClick={() => navigate('/blood-pressure-report')}
            style={{ flex: '1', minWidth: '200px', background: '#f16b6bff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '16px', color: '#f6f6f7ff' }}>Blood Pressure Usage</p>
                {statsBloodPressure !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600 }}>{statsBloodPressure}</h2>
                ) : (
                  <ComponentLoader color="#dc2626" padding="10px 0" />
                )}
                {/* <p style={{ margin: 0, fontSize: '12px', color: '#10b981' }}>↗ +18% from last month</p> */}
              </div>
              <div style={{ background: '#fef2f2', borderRadius: '10px', padding: '12px' }}>
                <FaHeartbeat style={{ color: '#dc2626', fontSize: '24px' }} />
              </div>
            </div>
          </div>


          {/* Blood Sugar */}
          <div
            onClick={() => navigate('/blood-sugar-report')}
            style={{ flex: '1', minWidth: '200px', background: '#f380e9ff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '16px', color: '#f6f6f7ff' }}>Blood Sugar</p>
                {statsBloodSugar !== null ? (
                  <h2 style={{ margin: '8px 0', fontSize: '32px', fontWeight: 600 }}>{statsBloodSugar}</h2>
                ) : (
                  <ComponentLoader color="#9333ea" padding="10px 0" />
                )}
                {/* <p style={{ margin: 0, fontSize: '12px', color: '#10b981' }}>↗ +10% from last month</p> */}
              </div>
              <div style={{ background: '#f3e8ff', borderRadius: '10px', padding: '12px' }}>
                <LuMicroscope style={{ color: '#9333ea', fontSize: '24px' }} />
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: '40px' }}>
          < OverallModuleUsage />
        </div>
      </div>
    </>
  )
}

export default Home